import React from 'react'
import { observer } from 'mobx-react'

const Name = ({ label, onClick, name, t }) => (
  <section>
    <label>
      <span>{label}</span>
    </label>
    <h2 onClick={onClick}>{name}</h2>
  </section>
)

export default observer(Name)
